// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file headless/v1/link.proto (package headless.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Money, PartialAuthInfo } from "../../common/v1/common_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Shopper } from "../../common/v1/shopper_pb";
import { Cart } from "../../merchant/v1/cart_pb";

/**
 * Specifies the payment type for link
 *
 * @generated from enum headless.v1.PaymentType
 */
export const PaymentType = proto3.makeEnum(
  "headless.v1.PaymentType",
  [
    {no: 0, name: "PAYMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_TYPE_SELL", localName: "SELL"},
    {no: 2, name: "PAYMENT_TYPE_DONATION", localName: "DONATION"},
  ],
);

/**
 * Specifies how the link is created.
 *
 * @generated from enum headless.v1.LinkSource
 */
export const LinkSource = proto3.makeEnum(
  "headless.v1.LinkSource",
  [
    {no: 0, name: "LINK_SOURCE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LINK_SOURCE_UNKNOWN", localName: "UNKNOWN"},
    {no: 2, name: "LINK_SOURCE_MPP", localName: "MPP"},
    {no: 3, name: "LINK_SOURCE_API", localName: "API"},
  ],
);

/**
 * Status of payment link
 *
 * @generated from enum headless.v1.LinkStatus
 */
export const LinkStatus = proto3.makeEnum(
  "headless.v1.LinkStatus",
  [
    {no: 0, name: "LINK_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LINK_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 3, name: "LINK_STATUS_INACTIVE", localName: "INACTIVE"},
    {no: 4, name: "LINK_STATUS_EXPIRED", localName: "EXPIRED"},
    {no: 5, name: "LINK_STATUS_PAID", localName: "PAID"},
    {no: 6, name: "LINK_STATUS_PENDING", localName: "PENDING"},
  ],
);

/**
 * Link representation
 * Next Id : 21
 *
 * @generated from message headless.v1.Link
 */
export const Link = proto3.makeMessageType(
  "headless.v1.Link",
  () => [
    { no: 1, name: "external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "reusable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "payment_type", kind: "enum", T: proto3.getEnumType(PaymentType) },
    { no: 7, name: "paid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "total", kind: "message", T: Money },
    { no: 9, name: "template_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "payment_link_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "expires_on", kind: "message", T: Timestamp },
    { no: 15, name: "source", kind: "enum", T: proto3.getEnumType(LinkSource) },
    { no: 16, name: "customer_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "shopper", kind: "message", T: Shopper },
    { no: 18, name: "status", kind: "enum", T: proto3.getEnumType(LinkStatus) },
    { no: 19, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "cart", kind: "message", T: Cart },
    { no: 21, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "partial_paid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "partial_auth_info", kind: "message", T: PartialAuthInfo, repeated: true },
  ],
);

